import { Icon } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';
import { useTheme } from '@Sage/hoi-poi-ui';
import { useSelector } from 'react-redux';
import { useDomainValidation } from '../../hooks/useDomainValidation';
import { canManageMarketingCampaigns } from '../../utils/marketingCampaignPermissions';

import './styles.scss';
import { Markdown } from '@Sage/hoi-poi-ui';

function DomainVerificationBanner() {
    const canManage = useSelector(canManageMarketingCampaigns);
    const { hasValidatedDomain, loading } = useDomainValidation();
    const theme = useTheme();

    if (!canManage || loading || hasValidatedDomain) return null;

    return (
        <div className="domain-verification-banner">
            <div className="domain-verification-banner__content">
                <Icon name="infoOutlined" color={theme.colors.semantic.caution600} />
                <Markdown
                    overrides={{
                        a: { target: '_blank' },
                    }}
                    content={getLiteral('label_marketing_campaigns_verify_domain_banner')}
                />
            </div>
        </div>
    );
}

DomainVerificationBanner.displayName = 'DomainVerificationBanner';

export default DomainVerificationBanner;
